import { render, staticRenderFns } from "./pronunciation.vue?vue&type=template&id=708d73a8&scoped=true"
import script from "./pronunciation.vue?vue&type=script&lang=js"
export * from "./pronunciation.vue?vue&type=script&lang=js"
import style0 from "./pronunciation.vue?vue&type=style&index=0&id=708d73a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d73a8",
  null
  
)

export default component.exports